import { useRouter } from "next/router"
import { useEffect, useContext } from "react"
import { useLocalStorage } from "react-use"
import routes from "routes"
import { globalStoreContext } from "src/store/GlobalStore"
import { ClientUserStateNumber } from "types"
import { getFirebaseTokenFromCookie } from "src/utils/auth/userCookies"

const FOR_MEMBER = 2
const FOR_NOT_COMPLETION_LOGIN = 1
const FOR_GUEST = 0

const usePermission = (
  stateNumber: ClientUserStateNumber[],
  redirectUrl = routes.authSignIn(),
) => {
  const router = useRouter()
  const accessToken = getFirebaseTokenFromCookie()

  const [redirectPage, setRedirectPage] = useLocalStorage<string>(
    "redirect_page",
    "",
  )

  const {
    globalStore: {
      user: { clientState, hasActiveRequest, apiUserData },
    },
  } = useContext(globalStoreContext)

  useEffect(() => {
    // usePermission([1, 2])
    // ログインフロー中、もしくはログイン後向けページは、未ログイン状態では見せない
    if (
      stateNumber.includes(FOR_NOT_COMPLETION_LOGIN) &&
      stateNumber.includes(FOR_MEMBER) &&
      accessToken === null
    ) {
      router.push(redirectUrl)
    }

    // usePermission([2])
    // メンバー向けページは、未ログイン状態では見せない
    else if (
      stateNumber.includes(FOR_MEMBER) &&
      !stateNumber.includes(FOR_NOT_COMPLETION_LOGIN) &&
      (accessToken === null || clientState === 1) &&
      hasActiveRequest !== 2
    ) {
      router.push(redirectUrl)
    }

    // usePermission([1])
    // 会員登録フロー中のページ
    else if (
      stateNumber.includes(FOR_NOT_COMPLETION_LOGIN) &&
      !stateNumber.includes(FOR_MEMBER)
    ) {
      if (clientState === 2) {
        router.push(routes.mypage())
      }

      if (accessToken === null || clientState === 0) {
        router.push(routes.authSignUp())
      }
    }

    // usePermission([0])
    // ゲスト向けページはFirebaseログイン後は見せない
    else if (stateNumber.includes(FOR_GUEST) && accessToken !== null) {
      // 元いたページがあればそちらに遷移させる
      // 新規会員登録フロー中は無視
      if (redirectPage && clientState !== 1) {
        router.push(redirectPage)
      } else {
        router.push(redirectUrl)
      }

      setRedirectPage("")
    }
    // 退会申請中は、メンバーー向けページは表示させない
    else if (
      stateNumber.includes(FOR_MEMBER) &&
      apiUserData &&
      apiUserData.will_resign_datetime !== null
    ) {
      router.push(routes.deactivate())
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientState, apiUserData])
}

export { usePermission }
